import {breakPoints, breakPointsMax} from './bootstrap';


// Smooth scroll of navigation links
// ========================================================================
let patternItems = UIkit.util.queryAll('.pattern-nav li [href^="#pattern-"]');
UIkit.scroll(patternItems, {
    duration: 500,
    offset: -30
});


// Navigation control of mobile devices
// ========================================================================
let ukAccordion, ukHeightMatch;
UIkit.util.on(window, 'load resize', e => {

    if (window.matchMedia(`(max-width: ${breakPointsMax.medium}px)`).matches) {

        ukAccordion = UIkit.accordion('.pattern-nav', {
            toggle: '> dl dt',
            content: '> dl dd',
            multiple: true,
            targets: '> * > *'
        });

        if (undefined !== ukHeightMatch) {
            ukHeightMatch.$emit('update');
        }

    } else {

        if (undefined !== ukAccordion) {
            ukAccordion.$destroy();

            let patternNav = UIkit.util.queryAll('.pattern-nav dd');
            UIkit.util.removeAttr(patternNav, 'aria-hidden hidden');
        }

        ukHeightMatch = UIkit.heightMatch('.pattern-nav > div', {
            target: '> * li a'
        });
        ukHeightMatch.$emit('update');

    }
});


// Ajax of preview display
// ========================================================================
const postRequestConfig = {
    timeout: 1000,
    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
};
let patterns = UIkit.util.queryAll('.patterns');

patterns = Array.prototype.slice.call(patterns, 0);
patterns.forEach((element, index) => {
    new Vue({
        el: element,
        data: {
            previewFileUrl: null,
        },
        methods: {
            preview() {
                axios.post(
                    `/preview/pattern/${index+1}`,
                    new FormData(document.getElementById(`form-pattern-${index + 1}`)),
                    postRequestConfig
                )
                .then(response => {
                    // console.log(response);

                    this.previewFileUrl = response.data.fileUrl;
                })
                .catch(error => {
                    console.log(error);
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js